import { useState } from 'react';
import { Button, Row, Col } from 'reactstrap';

//Components
import TextField from '../../../../../components/TextField';
import ModalCustomized from '../../../../../components/Modal/Modal';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import mascaras from '../../../../../helpers/mascaras';

export default function ModalRecalculoInfracoes({ infracoes, openRecalculoModal, setOpenRecalculoModal, setInfracoesRecalculadas, setIndiceRecalculo }) {
    const [indice, setIndice] = useState("0");

    const toggleRecalculoModal = () => setOpenRecalculoModal(!openRecalculoModal);

    const handleRecalcular = () => {
        const valorIndice = parseFloat(indice.replace(",", "."));

        if (isNaN(valorIndice) || valorIndice <= 0)
            return showMessage("Aviso", "Informe um índice válido", "warning", null);

        const recalculadas = infracoes.map(i => {
            const valorOriginalStr = i.valor != null ? i.valor.toString().replace(",", ".") : "0";
            const valorOriginal = parseFloat(valorOriginalStr) || 0;

            const variacao = valorOriginal * valorIndice;
            const novoValor = valorOriginal + variacao;

            return {
                ...i,
                valorAtualizado: novoValor.toFixed(2).replace(".", ","),
                valor: valorOriginal.toFixed(2).replace(".", ",")
            };
        });

        setInfracoesRecalculadas(recalculadas);
        setIndiceRecalculo(indice);
        toggleRecalculoModal();
    };

    return (
        <ModalCustomized
            size={'md'}
            fullscreen={"lg"}
            toggle={toggleRecalculoModal}
            widthPadrao={false}
            isOpen={openRecalculoModal}
            btnClose={toggleRecalculoModal}
            title={"Recalcular Infrações"}
        >
            <Row>
                <Col md={12} lg={12}>
                    <TextField
                        label="Índice a ser aplicado no cálculo:"
                        name="indice"
                        type="text"
                        value={indice}
                        onChange={(e) => setIndice(e.target.value)}
                        mask={mascaras.floatMask}
                    />
                </Col>
            </Row>

            <Row className='d-flex justify-content-center align-items-center mt-3'>
                <Col md={6} lg={4}>
                    <Button
                        color='secondary'
                        className='text-white fw-bold w-100'
                        onClick={toggleRecalculoModal}
                    >
                        Cancelar
                    </Button>
                </Col>
                <Col md={6} lg={4}>
                    <Button
                        color='success'
                        className='text-white fw-bold w-100'
                        onClick={handleRecalcular}
                    >
                        Recalcular
                    </Button>
                </Col>
            </Row>
        </ModalCustomized>
    );
}
